import { render, staticRenderFns } from "./BrowserFix.vue?vue&type=template&id=b5bfc38c&scoped=true"
import script from "./BrowserFix.vue?vue&type=script&lang=js"
export * from "./BrowserFix.vue?vue&type=script&lang=js"
import style0 from "./BrowserFix.vue?vue&type=style&index=0&id=b5bfc38c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bfc38c",
  null
  
)

export default component.exports